import { Component, Inject, Input } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-incidents-dialog',
  templateUrl: './incidents-dialog.component.html',
  styleUrls: ['./incidents-dialog.component.css']
})
export class IncidentsDialogComponent implements OnInit {
  productId: string;
  gcp: string;
  batchNum: string;
  gln: string;
  defaultTitle:string = "Incidents";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
    this.batchNum = this.data.batchNum;
    this.gln = this.data.gln;
  }
}